export const DARK_THEME = {
    BACKGROUND: '#23262E',
    TEXT: '#FFFFFF',
    PRIMARY: '#353946',
    SECONDARY: '#FFFFFF',
    TERTIARY: '#FFD6BA',
    BORDER: '#353946',
    COLORED_BUTTON_TEXT: '#23262E'
}